module.exports = __webpack_public_path__ + "static/media/dabajianshan4.e3d055f0.webp";